import { render } from "./Admission_Discharge_Guide.vue?vue&type=template&id=23b39713"
import script from "./Admission_Discharge_Guide.vue?vue&type=script&lang=js"
export * from "./Admission_Discharge_Guide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__